import * as React from "react";

import { UserAvatar } from "@/components/ui/userAvatar";
import { getUserDisplayName } from "@/helpers/userDisplay";
import type { DirectoryUsersById } from "./types";

interface Props {
  ownerId: string;
  usersById: DirectoryUsersById;
}

export const DriveOwnerCell: React.FC<Props> = ({ ownerId, usersById }) => {
  const owner = usersById.get(ownerId);
  const displayName = owner ? getUserDisplayName(owner) : ownerId;

  return (
    <div className="flex min-w-0 items-center gap-2">
      <UserAvatar user={owner} identifier={ownerId} size="xs" />
      <span className="truncate text-sm text-gray-700">{displayName}</span>
    </div>
  );
};
